import DeleteMinigridPresenter from "./DeleteMinigrid/DeleteMinigridPresenter"
import DescriptionMinigridPresenter from "./DescriptionMinigrid/DescriptionMinigridPresenter"
import EditBtnMinigridPresenter from "./EditBtnMinigrid/EditBtnMinigridPresenter"
import GalleryImagePresenter from "./GalleryImage/GalleryImagePresenter"
import LiveDashboardPresenter from "./LiveDashboard/LiveDashboardPresenter"
import LocationMapPresenter from "./LocationMap/LocationMapPresenter"
import LuminairesLinkPresenter from "./LuminairesLink/LuminairesLinkPresenter"
import MetersLinkPresenter from "./MetersLink/MetersLinkPresenter"
import PlanBTLinkPresenter from "./PlanBTLink/PlanBTLinkPresenter"
import PowerInfoPresenter from "./PowerInfo/PowerInfoPresenter"
import TitlePresenter from "./Title/TitlePresenter"
import UpdateMinigridFormPresenter from "./UpdateMinigridForm/UpdateMinigridFormPresenter"

export const SingleMinigrid = {
    Title : TitlePresenter,
    PowerInfo: PowerInfoPresenter,
    GalleryImage: GalleryImagePresenter,
    LocationMap:  LocationMapPresenter,
    Description: DescriptionMinigridPresenter,
    UpdateForm: UpdateMinigridFormPresenter,
    DeleteBtn: DeleteMinigridPresenter,
    EditBtn: EditBtnMinigridPresenter,
    LiveDashboard: LiveDashboardPresenter,
    MetersLink: MetersLinkPresenter,
    LuminairesLink: LuminairesLinkPresenter,
    PlanBTLink: PlanBTLinkPresenter,

}


export default SingleMinigrid